<template>
  <div class="request-location action-item shadow">
    <span class="title">Request Location Button</span>
    <div class="inner-content">
      <BasicInput v-model="requestLocation.buttonText" placeholder="Button text"/>
      <span @click="deleteItem"><Trash /></span>
    </div>
  </div>
</template>

<script>
import Trash from '@/components/icons/Trash';
import BasicInput from '@/components/inputs/BasicInput';

export default {
  data: () => {
    return {}
  },
  props: ['requestLocation'],
  mounted() {},
  methods: {
    deleteItem() {
      this.$emit("messageRemoveRequestLocation");
    }
  },
  components: { BasicInput, Trash }
}
</script>

<style lang="scss">
.request-location {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  border: 1px solid #555555;

  .title {
    font-size: 13px;
    margin-bottom: 8px;
  }
  .inner-content {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
